export const LOCAL_STORAGES = {
    ACCESS_TOKEN: "medqa_access_token",
    USER_ID: "medqa_user_id"
}